import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import { Image } from 'components/Shared/Image'
import { routes } from 'lib/routes'
import { ParsedUrlQuery } from 'querystring'
import React from 'react'

import { ClosedBadge, OpenBadge } from './shared'
import { DirectoryVCVenue } from './utils'

interface Props {
  vcVenue: DirectoryVCVenue
  query: ParsedUrlQuery
  color?: string
}

export const VenueCard = ({ vcVenue, query, color }: Props) => {
  if (!vcVenue || !vcVenue.venue) {
    return null
  }

  const name = vcVenue.name || vcVenue.venue.name

  return (
    <RouteLink
      route={routes.venue}
      pathData={{
        venueSlug: vcVenue.venue.slug,
        number: query.number,
        area: query.area,
        place: query.place,
      }}
    >
      <a className="block rounded bg-surface">
        <div className="relative mb-3 h-0 overflow-hidden rounded bg-surface-subtle pt-[calc(9/16*100%)]">
          <div className="absolute inset-0">
            {vcVenue.venue?.image && (
              <Image
                image={vcVenue.venue.image}
                sizes="280px"
                alt={name}
                layout="fill"
              />
            )}
          </div>

          {vcVenue.venue.isClosed && (
            <div className="absolute inset-0 bg-black/50" />
          )}
        </div>
        <div className="pb-8 md:px-4">
          {vcVenue.venue.isClosed ? (
            <ClosedBadge color={color} />
          ) : (
            <OpenBadge color={color} />
          )}
          <div className="text-foreground my-heading-sm">{name}</div>
          <p className="mb-2 mt-3 text-foreground-subtle my-body-md">
            {vcVenue.vcName}
          </p>
        </div>
      </a>
    </RouteLink>
  )
}
